import React, { useEffect, useState } from "react";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { BtnGiaHan } from "components/DanhSachTaiSan/ChucNang/GiaHan/BtnGiaHan";
import { BtnChoThue } from "components/DanhSachTaiSan/ChucNang/ChoThue/BtnChoThue";
import { BtnChuyenKho } from "components/DanhSachTaiSan/ChucNang/ChuyenKho/BtnChuyenKho";
import { BtnInMaVach } from "components/DanhSachTaiSan/ChucNang/BtnInMaVach";
import { BtnSoHuu } from "components/DanhSachTaiSan/ChucNang/SoHuu/BtnSoHuu";
import { BtnThanhLy } from "components/DanhSachTaiSan/ChucNang/ThanhLy/BtnThanhLy";
import { BtnThuHoi } from "components/DanhSachTaiSan/ChucNang/ThuHoi/BtnThuHoi";
import { BtnSua } from "components/DanhSachTaiSan/ChucNang/BtnSua";
import { DSTaiSanConst } from "constants/danhSachTaiSanConst";
import { formatNumber } from "utils/currencyFormat";
// import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import { BtnChiTietTaiSan } from "./BtnChiTietTaiSan";
import { BtnChiTietHopDong } from "./BtnChiTietHopDong";
import { BtnXoa } from "./ChucNang/Xoa/BtnXoa";
import { useSelector, useDispatch } from "react-redux";

const QUYEN_NUT = {
  chuyenKho: "danhsachtaisan_chuyenkho",
  thanhLy: "danhsachtaisan_thanhlytaisan",
  soHuu: "danhsachtaisan_sohuutaisan",
  thuHoi: "danhsachtaisan_thuhoitaisan",
  sua: "danhsachtaisan_suataisan",
  choThue: "danhsachtaisan_chothuetaisan",
  xoa: "danhsachtaisan_xoataisan",
};

export const ContentTable = ({ listtaisan, dsQuyen = [] }) => {
  const listTaisanFull = useSelector((state) => state.listTaiSanFull); //listTaiSanFul dinh nghia o rootreducer

  const coQuyen = (ma) => dsQuyen.includes(ma);
  // {
  //   console.log(listTaisanFull);
  // }
  return listtaisan.map((item, index) => (
    <div className="custom-table-row" key={"item" + 1}>
      <div className="custom-table-cell username-cell flex-basis-5 flex-basis-6-npt flex-basis-6-sm disk-mobile">
        <span className="mobile-column-name">STT</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.IndexId}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-16 flex-basis-13-npt flex-basis-14-sm">
        <span className="mobile-column-name">Mã tài sản</span>
        <div className="center-wrapper text-center  word-break">
          <BtnChiTietTaiSan taisan={item} />
          {/* <a
            onClick={handleShowChiTietTaiSan}
            href={() => false}
            className="blue"
          >
            <p className="text-center">{item.MaTaiSan}</p>
          </a> */}
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-npt flex-basis-13-sm">
        <span className="mobile-column-name">Tên tài sản</span>
        <div className="center-wrapper">
          <p className="text-center color7 word-break">{item.TenTaiSan}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-13 flex-basis-9-npt flex-basis-11-sm">
        <span className="mobile-column-name">Kho</span>
        <div className="center-wrapper">
          <p className="text-center color7">{item.TenKho}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-11-2-npt flex-basis-9-sm">
        <span className="mobile-column-name">Hợp đồng</span>
        <div className="center-wrapper">
          <p className="text-center  word-break color7">
            {item.Status !== 11 && item.Status !== 12 && (
              <BtnChiTietHopDong taisan={item} />
            )}
            {item.Status === 11 && item.MaHopDong}
            {item.Status === 12 && item.MaHopDong}
            {/* {item.MaHopDong} */}
            {/* <a onClick={handleShow} href={() => false} className="blue">
              {item.MaHopDong}
            </a> */}
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-11 flex-basis-12-8-npt flex-basis-12-sm">
        <span className="mobile-column-name">Khách hàng</span>
        <div className="center-wrapper">
          <p className="color7  word-break">{item.TenKhachHang}</p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-12-npt flex-basis-12-sm">
        <span className="mobile-column-name">Số tiền</span>
        <div className="center-wrapper">
          <p className="text-right">
            <span className="color7">{formatNumber(item.SoTienVay)}</span>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-10 flex-basis-10-npt flex-basis-11-sm ">
        <span className="mobile-column-name">Trạng thái</span>
        <div className="center-wrapper">
          <p className="text-center ">
            <span
              className={
                item.Status === DSTaiSanConst.TinhTrangTaiSan.DaThanhLy
                  ? "canh-bao-xam-v2"
                  : item.Status === DSTaiSanConst.TinhTrangTaiSan.DangCamDo
                    ? "canh-bao-xanh-da-troi-v2"
                    : item.Status === DSTaiSanConst.TinhTrangTaiSan.CanThanhLy
                      ? "canh-bao-no"
                      : item.Status ===
                          DSTaiSanConst.TinhTrangTaiSan.DangChoThue
                        ? "dang-vay"
                        : item.Status === DSTaiSanConst.TinhTrangTaiSan.SoHuu
                          ? "dang-vay"
                          : item.Status ===
                              DSTaiSanConst.TinhTrangTaiSan.CamNhanVay
                            ? "canh-bao-xam-v2"
                            : item.Status ===
                                DSTaiSanConst.TinhTrangTaiSan.DaTra
                              ? "canh-bao-xam-v2"
                              : item.Status ===
                                  DSTaiSanConst.TinhTrangTaiSan.CanThuHoi
                                ? "canh-bao-red-v2"
                                : item.Status ===
                                    DSTaiSanConst.TinhTrangTaiSan.CanChuocDo
                                  ? "canh-bao-red-v2"
                                  : item.Status ===
                                      DSTaiSanConst.TinhTrangTaiSan.NhapHang
                                    ? "canh-bao-xam-v2"
                                    : "canh-bao-xam-v2"
              }
            >
              {item.Status === DSTaiSanConst.TinhTrangTaiSan.DangCamDo &&
              item.TypeHopDong === 2
                ? "Đang trả góp"
                : item.TenTrangThai}
            </span>
          </p>
        </div>
      </div>

      <div className="custom-table-cell flex-basis-12 flex-basis-16-npt flex-basis-12-sm  action-cell">
        <div className="center-wrapper">
          {item.Status === 6 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 10 && (
            <div className="iconTableMormanCenter">
              {coQuyen(QUYEN_NUT.chuyenKho) && (
                <BtnChuyenKho TaiSanID={item.TaiSanID} />
              )}
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 7 && (
            <div className="iconTableMormanCenter">
              {coQuyen(QUYEN_NUT.thanhLy) && (
                <BtnThanhLy hopdong={item} TaiSanID={item.TaiSanID} />
              )}
              {coQuyen(QUYEN_NUT.soHuu) && (
                <BtnSoHuu TaiSanID={item.TaiSanID} />
              )}
              {coQuyen(QUYEN_NUT.chuyenKho) && (
                <BtnChuyenKho TaiSanID={item.TaiSanID} />
              )}
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 3 && (
            <div className="iconTableMormanCenter">
              {coQuyen(QUYEN_NUT.thuHoi) && <BtnThuHoi item={item} />}
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 4 && (
            <div className="iconTableMormanCenter">
              {coQuyen(QUYEN_NUT.sua) && <BtnSua TaiSanID={item.TaiSanID} />}
              {/* <BtnThanhLy hopdong={item} TaiSanID={item.TaiSanID} /> */}
              {coQuyen(QUYEN_NUT.choThue) && (
                <BtnChoThue
                  TaiSanID={item.TaiSanID}
                  trangthai={item.TenTrangThai}
                />
              )}
              {coQuyen(QUYEN_NUT.chuyenKho) && (
                <BtnChuyenKho TaiSanID={item.TaiSanID} />
              )}
              <BtnInMaVach item={item} />
              {coQuyen(QUYEN_NUT.xoa) && <BtnXoa TaiSanID={item.TaiSanID} />}
            </div>
          )}
          {item.Status === 5 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 2 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 8 && (
            <div className="iconTableMormanCenter">
              {coQuyen(QUYEN_NUT.thuHoi) && <BtnThuHoi item={item} />}
              <BtnGiaHan TaiSanID={item.TaiSanID} />
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 9 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 11 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
          {item.Status === 12 && (
            <div className="iconTableMormanCenter">
              <BtnInMaVach item={item} />
            </div>
          )}
        </div>
      </div>
      {/* <ChiTietHopDongContainer
        show={show}
        onHide={handleClose}
        data={item}
      ></ChiTietHopDongContainer> */}
    </div>
  ));
};
